<template>
  <div>
    <CForm @submit.prevent="submit">
      <CModal centered :close-on-backdrop="false" :show.sync="properties.visible">
        <template #header>
          <h5 class="modal-title">
            <i class="fa fa-user-o fa-fw" aria-hidden="true"></i>
            사용자 비밀번호 변경
          </h5>
          <CButtonClose @click="properties.visible = false"></CButtonClose>
        </template>

        <ValidationObserver ref="observer">
          <ValidationProvider
            v-slot="{ errors }"
            name="currentPassword"
            rules="required|min:4|max:20"
          >
            <CInput
              label="현재 비밀번호"
              placeholder="현재 비밀번호를 입력하세요"
              type="password"
              horizontal
              v-model="form.currentPassword"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CInput>
          </ValidationProvider>

          <ValidationProvider v-slot="{ errors }" name="newPassword" rules="required|min:9|max:20">
            <CInput
              label="신규 비밀번호"
              placeholder="신규 비밀번호를 입력하세요"
              type="password"
              horizontal
              v-model="form.newPassword"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CInput>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            name="newConfirmPassword"
            rules="required|password:@newPassword|min:9|max:20"
          >
            <CInput
              label="신규 비밀번호 확인"
              placeholder="신규 비밀번호를 다시 입력하세요"
              type="password"
              horizontal
              v-model="form.newConfirmPassword"
              :invalid-feedback="errors.length > 0 ? errors[0] : ''"
              :is-valid="errors.length > 0 ? false : null"
            >
            </CInput>
          </ValidationProvider>
        </ValidationObserver>

        <template #footer>
          <CButton @click="properties.visible = false" color="secondary"> 취소</CButton>
          <CButton type="submit" color="success"> 저장</CButton>
        </template>
      </CModal>
    </CForm>
  </div>
</template>

<script>
import { extend, localize, ValidationObserver, ValidationProvider } from "vee-validate";
import { email, max, min, required } from "vee-validate/dist/rules";
import Constant from "@/store/constant";
import core from "@/core";
import MixinsModalBackButton from "@/mixins/modal-back-button";
import UserService from "@/services/user/user.service";

extend("required", required);
extend("email", email);
extend("min", min);
extend("max", max);
extend("password", {
  params: ["target"],
  validate(value, { target }) {
    //console.log('value : ', value, ', target : ', target);
    return value === target;
  },
  message: "비밀번호 확인이 일치하지 않습니다",
});
extend("phone", {
  validate(value) {
    return core.utils.validate.phone(value);
  },
  message: "휴대전화 형식이 올바르지 않습니다",
});

localize("ko", {
  messages: Constant.validate.language.korea.messages,
  names: {
    currentPassword: "현재 비밀번호",
    newPassword: "신규 비밀번호",
    newConfirmPassword: "신규 비밀번호 확인",
  },
});

export default {
  name: "UserChangePasswordModal",
  mixins: [MixinsModalBackButton()],
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          visible: false,
          params: {},
          watchClose: {
            result: "",
            item: null,
          },
        };
      },
    },
  },
  data() {
    return {
      form: {
        currentPassword: "",
        newPassword: "",
        newConfirmPassword: "",
      },
    };
  },
  mounted() {
    this.$nextTick(async () => {
      core.loader.hide();
    });
  },
  destroyed() {
    const modal = this.$store.state.app.modal.profile;
    modal.visible = true;
  },
  methods: {
    changeValue(changed) {
      const $this = this;
      if (changed != null) {
        $this.backButton.changed = changed;
      } else {
        $this.backButton.changed = true;
      }
    },
    async submit() {
      const observer = this.$refs.observer;
      const isValid = await observer.validate();
      if (isValid) {
        core.loader.show();
        try {
          await UserService.updatePassword(this.form);
          // let result = await FacilityService.create(params);
          // console.log("result : ", result);
          this.properties.watchClose = {
            result: "confirm",
          };
          this.properties.visible = false;
        } catch (e) {
          console.log("error : ", e);
          const errorFieldName = e.errorFieldName;
          if (errorFieldName != null) {
            const errors = observer.errors[errorFieldName];
            if (errors != null) {
              errors.push(e.message);
            } else {
              console.log(`not found error field '${errorFieldName}'`);
            }
            console.log(observer.errors);
          }
        }
        core.loader.hide();
      } else {
        console.log("errors : ", observer.errors);
      }
    },
  },
};
</script>
